import dayjs from "dayjs";

export const validateTransactionDate = (date, walletCreatedAt, minDate, t) => {
	if (!date || !date.isValid()) {
		return t("enterTransactionsDate");
	}
	if (date.isAfter(dayjs(), "day")) {
		return t("transactionDateInFutureError");
	}
	if (walletCreatedAt && date.isBefore(dayjs(walletCreatedAt), "day")) {
		return t("transactionDateBeforeWalletError").replace(
			"{walletDate}",
			dayjs(walletCreatedAt).format("DD.MM.YYYY")
		);
	}
	if (date.isBefore(minDate, "day")) {
		return t("transactionDateIsTooOldError");
	}
	return null;
};

export const validateWalletBalance = (
	amount,
	walletBalance,
	historicalBalance,
	currency,
	isPending,
	hasError,
	t
) => {
	if (isPending) {
		return t("loadingWalletValuePleaseWait");
	}
	if (hasError) {
		return t("cannotCheckWalletHistoricalBalance");
	}

	const parsedAmount = parseFloat(amount);

	if (parsedAmount > walletBalance) {
		return t("transactionGreaterThanWalletBalanceError")
			.replace("{amount}", walletBalance)
			.replace("{currency}", currency);
	}

	if (historicalBalance !== undefined && parsedAmount > historicalBalance) {
		return t("transactionGreaterThanWalletBalanceAtDateError")
			.replace("{amount}", historicalBalance)
			.replace("{currency}", currency);
	}

	return null;
};

export const validateLinkedWallet = (
	newAmount,
	originalAmount,
	linkedWallet,
	historicalValue,
	selectedDate,
	originalDate,
	isPending,
	hasError,
	t
) => {
	if (!linkedWallet) return null;

	const errors = {};

	if (selectedDate !== originalDate) {
		if (selectedDate.isBefore(dayjs(linkedWallet.createdAt), "day")) {
			errors.date = t(
				"transactionDateBeforeConnectedAssetLiabilityError"
			).replace(
				"{walletDate}",
				dayjs(linkedWallet.createdAt).format("DD.MM.YYYY")
			);
		}
	}

	if (isPending) {
		errors.amount = t("loadingWalletValuePleaseWait");
		return errors;
	}

	if (hasError) {
		errors.amount = t("cannotCheckWalletHistoricalBalance");
		return errors;
	}

	if (newAmount === originalAmount) return errors;

	const historicalValueCorrected = historicalValue + originalAmount;
	const currentValueCorrected = linkedWallet.balance + originalAmount;

	if (newAmount > 0 && linkedWallet.type === "asset") {
		if (newAmount > historicalValueCorrected) {
			errors.amount = t(
				"transactionGreaterThanConnectedAssetLiabilityBalanceAtDateError"
			)
				.replace("{amount}", historicalValueCorrected.toFixed(2))
				.replace("{currency}", linkedWallet.currency);
		} else if (newAmount > currentValueCorrected) {
			errors.amount = t(
				"transactionGreaterThanConnectedAssetLiabilityBalanceError"
			)
				.replace("{amount}", currentValueCorrected.toFixed(2))
				.replace("{currency}", linkedWallet.currency);
		}
	}

	if (newAmount < 0 && linkedWallet.type === "liability") {
		if (newAmount < historicalValueCorrected) {
			errors.amount = t(
				"transactionGreaterThanConnectedAssetLiabilityBalanceAtDateError"
			)
				.replace("{amount}", historicalValueCorrected.toFixed(2))
				.replace("{currency}", linkedWallet.currency);
		} else if (newAmount < currentValueCorrected) {
			errors.amount = t(
				"transactionGreaterThanConnectedAssetLiabilityBalanceError"
			)
				.replace("{amount}", currentValueCorrected.toFixed(2))
				.replace("{currency}", linkedWallet.currency);
		}
	}

	return errors;
};

export const validateMarkAsLinkedWallet = (
	selectedType,
	amount,
	wallet,
	historicalBalance,
	transactionDate,
	isPending,
	hasError,
	t
) => {
	if (!selectedType || !wallet) return null;

	if (new Date(wallet.createdAt) > new Date(transactionDate)) {
		return t("transactionMarkAsWalletDateError", {
			walletDate: dayjs(wallet.createdAt).format("DD.MM.YYYY"),
		});
	}

	if (isPending) {
		return t("loadingWalletValuePleaseWait");
	}

	if (hasError) {
		return t("cannotCheckWalletHistoricalBalance");
	}

	if (selectedType === "asset" && amount > 0) {
		if (amount > wallet.balance) {
			return t("withdrawalGreaterThanAssetAmountError")
				.replace("{amount}", wallet.balance)
				.replace("{currency}", wallet.currency);
		}
		if (historicalBalance !== undefined && amount > historicalBalance) {
			return t("withdrawalGreaterThanAssetAmountAtDateError")
				.replace("{amount}", historicalBalance)
				.replace("{currency}", wallet.currency);
		}
	}

	if (selectedType === "liability" && amount < 0) {
		if (amount < wallet.balance) {
			return t("debtPaymentGreaterThanDebtAmountError")
				.replace("{amount}", wallet.balance)
				.replace("{currency}", wallet.currency);
		}
		if (historicalBalance !== undefined && amount < historicalBalance) {
			return t("debtPaymentGreaterThanDebtAmountAtDateError")
				.replace("{amount}", historicalBalance)
				.replace("{currency}", wallet.currency);
		}
	}

	return null;
};

export const validateRequiredFields = (fields, t) => {
	const errors = {};

	if (!fields.amount) {
		errors.amount = t("enterTransactionsAmount");
	}
	if (!fields.wallet) {
		errors.wallet = t("enterTransactionsWallet");
	}
	if (!fields.type) {
		errors.type = t("enterTransactionsType");
	}
	if (fields.type && !fields.category) {
		errors.category = t("enterTransactionsCategory");
	}

	return errors;
};
